import type { RuleGraphNode } from "@intelligems/ig-types/dtos/agentic-logic/rule-graph";
import { FALLBACK_TERMINAL_BODY } from "./FALLBACK_TERMINAL_BODY";

export const fallbackTerminalBodyText = (node: RuleGraphNode): string =>
  node.label.trim() === "" || node.label.trim() === "…"
    ? FALLBACK_TERMINAL_BODY
    : node.label;
